import React, { useState } from "react";
import { Pulse, CaretDown, CaretUp } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { api } from "../lib/api";
import { formatApiError } from "../lib/auth";

const JOB_NAMES = { vip_tracker: "Tracker VIP", tracker: "Tracker general", stock_watch: "Stock Watch" };

const ago = (iso) => {
  if (!iso) return "nunca";
  const m = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  return m < 1 ? "hace <1 min" : m < 60 ? `hace ${m} min` : `hace ${Math.round(m / 60)} h`;
};

function Row({ label, value, bad, testid }) {
  return (
    <div className={`flex justify-between gap-3 px-3 py-1.5 border ${bad ? "border-red-300 bg-red-50 text-red-800" : "border-zinc-200"}`} data-testid={testid}>
      <span className="truncate">{label}</span>
      <span className="font-bold shrink-0 text-right">{value}</span>
    </div>
  );
}

export function TrackerDiagnostics() {
  const [open, setOpen] = useState(false);
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);

  const load = async () => {
    setErr(null);
    try { setD((await api.get("/admin/diagnostics")).data); } catch (e) { setErr(formatApiError(e)); }
  };
  const toggle = () => { if (!open) load(); setOpen(!open); };

  return (
    <div className="border-2 border-zinc-950 bg-white mb-6" data-testid="tracker-diagnostics">
      <button onClick={toggle} className="w-full flex items-center justify-between px-4 py-3 font-mono text-xs uppercase tracking-widest" data-testid="tracker-diagnostics-toggle">
        <span className="flex items-center gap-2"><Pulse size={14} weight="bold" /> Diagnóstico de revisiones automáticas</span>
        {open ? <CaretUp size={14} /> : <CaretDown size={14} />}
      </button>
      {open && (
        <div className="px-4 pb-4 space-y-3 font-mono text-[11px]">
          {err && <p className="text-red-700">{err}</p>}
          {d && (
            <>
              <div className="space-y-1">
                <Row label="Servidor encendido desde" value={ago(d.server_started_at)} testid="diag-server-started" />
                <Row label="Temporizador interno" value={d.scheduler_running ? "activo" : "DETENIDO"} bad={!d.scheduler_running} testid="diag-scheduler" />
                <Row label="Cron" value={d.cron_runs.length ? `última ${ago(d.cron_runs[0].at)}` : "aún sin llamadas"} bad={!d.cron_runs.length} testid="diag-cron" />
              </div>
              <div className="space-y-1">
                <p className="uppercase tracking-widest text-zinc-500">Última revisión</p>
                {Object.entries(JOB_NAMES).map(([k, name]) => {
                  const hb = d.heartbeats.find((h) => h.name === k);
                  return <Row key={k} label={`${name}${hb?.source ? ` (${hb.source})` : ""}`} value={hb?.last_error ? `ERROR ${ago(hb.last_started_at)}` : hb && (!hb.last_finished_at || hb.last_finished_at < hb.last_started_at) ? `en curso / sin terminar · ${ago(hb.last_started_at)}` : ago(hb?.last_started_at)} bad={!hb || !!hb.last_error} testid={`diag-job-${k}`} />;
                })}
              </div>
              {d.telegram_errors.length > 0 && (
                <div className="space-y-1">
                  <p className="uppercase tracking-widest text-red-700">Errores de Telegram</p>
                  {d.telegram_errors.slice(0, 5).map((e, i) => <Row key={i} label={`${e.chat_id}: ${e.error}`} value={ago(e.at)} bad />)}
                </div>
              )}
              {d.link_errors.length > 0 && (
                <div className="space-y-1">
                  <p className="uppercase tracking-widest text-red-700">Envíos con error</p>
                  {d.link_errors.slice(0, 5).map((l, i) => <Row key={i} label={`${l.label}: ${l.last_error}`} value={ago(l.last_checked_at)} bad />)}
                </div>
              )}
              <div className="space-y-1">
                <p className="uppercase tracking-widest text-zinc-500">Últimos cambios detectados</p>
                {d.recent_changes.slice(0, 5).map((h, i) => <Row key={i} label={h.label} value={`${h.telegram_sent ? "Telegram OK" : "SIN Telegram"} · ${ago(h.created_at)}`} bad={!h.telegram_sent} />)}
              </div>
            </>
          )}
          <Button onClick={load} variant="outline" className="rounded-none border-zinc-950 font-mono uppercase text-xs" data-testid="tracker-diagnostics-refresh">Actualizar</Button>
        </div>
      )}
    </div>
  );
}
